module.exports = __webpack_public_path__ + "img/Eventos_registrar_participantes.a6a76f06.svg";